<template>
    <div class="top-des d-b p-r m-0-a">
        <div class="left-pic p-a">
            <img :src="info.gameIcon" alt="">
        </div>
        <p class="text-elli mb-f-s-24 f-w-b">{{info.title}}</p>
        <p class="text-elli mb-f-s-l">{{info.des}}</p>
        <a class="right-pic d-b p-a t-a-r" @click="Ga()">
            <img :src="info.register" alt="">
        </a>
    </div>
</template>
<style lang="less" scoped>
    .top-des {
        width: 9.653333rem;
        height: 1.333333rem;
        padding: .25rem 2.4rem 0 1.2rem;
        background: #000;
        img {
            max-width: 100%;
        }
        .right-pic,
        .left-pic {
            height: 100%;
            top: 50%;
        }
        .left-pic {
            width: 1.066667rem;
            height: 1.066667rem;
            left: 0;
            margin-top: -.533333rem;
        }
        .right-pic {
            width: 2.346667rem;
            height: .8rem;
            right: 0;
            margin-top: -.4rem;
            cursor: pointer;
        }
    }
</style>

<script>
    import Util from "@util/index.js";
    export default {
        props: ['info', 'lan'],
        methods: {
            Ga() {
                Util.trackGA('点击', '跳转至' + this.lan + ' :版头跳转-预约页面', '跳转至' + this.lan + ' :版头跳转-预约页面');
                window.location.href = this.info.link;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// client/smsgz/components/index/top-des.vue